import { service } from "../server/request";

export const getCatererData=async(catererId)=>{
    try{      
        let url=`mealManage/caterers/${catererId}`;
       
       const resp= await service({
            method:'GET',
            url:url
        });
        if(resp.status===200){
            return {success:true,data:resp.data};
        }
    }catch(ex){
        return {error:true,errorMessage:ex.errorMessage}
    }
}
export const saveUserRec=async(req)=>{
    const {catererId}=req;
    try {
        let url=`mealManage/${catererId}/caterer`;
        const resp= await service({
            method:'PUT',
            data:req,
            url:url,
        });
        if(resp.status==200){            
            return {success:true,data:resp.data};
        }else{
            return {error:true,errorMessage:resp.data.errorMessage};
        }
    }catch(ex){
        const errorObject=ex;
		const errorMessage=errorObject.message;
		return {error:true,errorMessage:errorMessage}
    }
}
export const sendActivationLink=async(req)=>{
    const {username}=req;
    try {
        let url=`mealManage/catererAccActivation?username=${username}`;
        const resp= await service({
            method:'GET',
            url:url,
        });
        if(resp.status==200){            
            return {success:true,data:resp.data};
        }else{
            return {error:true,errorMessage:resp.data.statusMessage};
        }
    }catch(ex){
        const errorObject=ex;
		const errorMessage=errorObject.statusMessage;
		return {error:true,errorMessage:errorMessage}
    }
}

export const getCountrySettings=async()=>{
    try{
        let url=`mealManage/countryDetails`;
        const resp= await service({
            method:'GET',
            url:url,
        });
        if(resp.status==200){            
            return {success:true,data:((resp.data||{})._embedded||{}).countryDetails||[]};
        }else{
            return {error:true,errorMessage:resp.data.statusMessage};
        }
    }catch(ex){
        const errorObject=ex;
		const errorMessage=errorObject.statusMessage;
		return {error:true,errorMessage:errorMessage}
    }
}